<img [src]="src || placeholderSrc"
  [srcset]="srcset"
  [sizes]="sizes"
  [alt]="alt"
  [attr.loading]="nativeLazy ? 'lazy' : 'eager'"
  [ngStyle]="imgStyle">